
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lXnaE"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4EDQB"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("63Sa6"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("KFpBB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("4e9mM"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gcnRn"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("i52gf"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("4doEc"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("kFJwL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("5shOo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("3Hycf"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("5S3Gg"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lXnaE", function(module, exports) {

let $ffc114e09dca3abb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffc114e09dca3abb$var$load("2YffH"),
    $ffc114e09dca3abb$var$load("1o23t"),
    $ffc114e09dca3abb$var$load("b7OPx"),
    $ffc114e09dca3abb$var$load("lqFMg"),
    $ffc114e09dca3abb$var$load("gELW6"),
    $ffc114e09dca3abb$var$load("4hDGB"),
    $ffc114e09dca3abb$var$load("7o5Pu"),
    $ffc114e09dca3abb$var$load("1H5IN"),
    $ffc114e09dca3abb$var$load("eBRUf"),
    $ffc114e09dca3abb$var$load("hwT9D"),
    $ffc114e09dca3abb$var$load("j4Bpe"),
    $ffc114e09dca3abb$var$load("h4Nf7"),
    $ffc114e09dca3abb$var$load("7f9Fz"),
    $ffc114e09dca3abb$var$load("8YSo7"),
    $ffc114e09dca3abb$var$load("7do1E"),
    $ffc114e09dca3abb$var$load("77dkW"),
    $ffc114e09dca3abb$var$load("g9CVe"),
    $ffc114e09dca3abb$var$load("9hYRW"),
    $ffc114e09dca3abb$var$load("kpm7S"),
    $ffc114e09dca3abb$var$load("6wr18"),
    $ffc114e09dca3abb$var$load("kjZZD"),
    $ffc114e09dca3abb$var$load("3JSgG"),
    $ffc114e09dca3abb$var$load("9AXkC"),
    $ffc114e09dca3abb$var$load("ffEVr"),
    $ffc114e09dca3abb$var$load("28arV"),
    $ffc114e09dca3abb$var$load("l1BQC"),
    $ffc114e09dca3abb$var$load("jlSF3"),
    $ffc114e09dca3abb$var$load("2vAWg"),
    $ffc114e09dca3abb$var$load("7cABH"),
    $ffc114e09dca3abb$var$load("31vk5"),
    $ffc114e09dca3abb$var$load("4pqtR"),
    $ffc114e09dca3abb$var$load("5XqRg"),
    $ffc114e09dca3abb$var$load("2uVTT"),
    $ffc114e09dca3abb$var$load("hhss7"),
    $ffc114e09dca3abb$var$load("Wowvf"),
    $ffc114e09dca3abb$var$load("5RR9C"),
    $ffc114e09dca3abb$var$load("2PePB"),
    $ffc114e09dca3abb$var$load("bIPPg"),
    $ffc114e09dca3abb$var$load("lnKog"),
    $ffc114e09dca3abb$var$load("h3ABO"),
    $ffc114e09dca3abb$var$load("kC80R"),
    $ffc114e09dca3abb$var$load("7EorR"),
    $ffc114e09dca3abb$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4EDQB", function(module, exports) {

let $3639ceb76464ee37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3639ceb76464ee37$var$load("2YffH"),
    $3639ceb76464ee37$var$load("1o23t"),
    $3639ceb76464ee37$var$load("b7OPx"),
    $3639ceb76464ee37$var$load("lqFMg"),
    $3639ceb76464ee37$var$load("gELW6"),
    $3639ceb76464ee37$var$load("4hDGB"),
    $3639ceb76464ee37$var$load("7o5Pu"),
    $3639ceb76464ee37$var$load("1H5IN"),
    $3639ceb76464ee37$var$load("eBRUf"),
    $3639ceb76464ee37$var$load("hwT9D"),
    $3639ceb76464ee37$var$load("j4Bpe"),
    $3639ceb76464ee37$var$load("h4Nf7"),
    $3639ceb76464ee37$var$load("7f9Fz"),
    $3639ceb76464ee37$var$load("8YSo7"),
    $3639ceb76464ee37$var$load("7do1E"),
    $3639ceb76464ee37$var$load("77dkW"),
    $3639ceb76464ee37$var$load("g9CVe"),
    $3639ceb76464ee37$var$load("9hYRW"),
    $3639ceb76464ee37$var$load("kpm7S"),
    $3639ceb76464ee37$var$load("6wr18"),
    $3639ceb76464ee37$var$load("kjZZD"),
    $3639ceb76464ee37$var$load("3JSgG"),
    $3639ceb76464ee37$var$load("9AXkC"),
    $3639ceb76464ee37$var$load("ffEVr"),
    $3639ceb76464ee37$var$load("28arV"),
    $3639ceb76464ee37$var$load("l1BQC"),
    $3639ceb76464ee37$var$load("jlSF3"),
    $3639ceb76464ee37$var$load("2vAWg"),
    $3639ceb76464ee37$var$load("7cABH"),
    $3639ceb76464ee37$var$load("31vk5"),
    $3639ceb76464ee37$var$load("4pqtR"),
    $3639ceb76464ee37$var$load("5XqRg"),
    $3639ceb76464ee37$var$load("2uVTT"),
    $3639ceb76464ee37$var$load("hhss7"),
    $3639ceb76464ee37$var$load("Wowvf"),
    $3639ceb76464ee37$var$load("5RR9C"),
    $3639ceb76464ee37$var$load("2PePB"),
    $3639ceb76464ee37$var$load("bIPPg"),
    $3639ceb76464ee37$var$load("lnKog"),
    $3639ceb76464ee37$var$load("h3ABO"),
    $3639ceb76464ee37$var$load("kC80R"),
    $3639ceb76464ee37$var$load("7EorR"),
    $3639ceb76464ee37$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("63Sa6", function(module, exports) {

let $469d0953f050b025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $469d0953f050b025$var$load("2YffH"),
    $469d0953f050b025$var$load("1o23t"),
    $469d0953f050b025$var$load("b7OPx"),
    $469d0953f050b025$var$load("lqFMg"),
    $469d0953f050b025$var$load("gELW6"),
    $469d0953f050b025$var$load("4hDGB"),
    $469d0953f050b025$var$load("7o5Pu"),
    $469d0953f050b025$var$load("1H5IN"),
    $469d0953f050b025$var$load("eBRUf"),
    $469d0953f050b025$var$load("hwT9D"),
    $469d0953f050b025$var$load("j4Bpe"),
    $469d0953f050b025$var$load("h4Nf7"),
    $469d0953f050b025$var$load("7f9Fz"),
    $469d0953f050b025$var$load("8YSo7"),
    $469d0953f050b025$var$load("7do1E"),
    $469d0953f050b025$var$load("77dkW"),
    $469d0953f050b025$var$load("g9CVe"),
    $469d0953f050b025$var$load("9hYRW"),
    $469d0953f050b025$var$load("kpm7S"),
    $469d0953f050b025$var$load("6wr18"),
    $469d0953f050b025$var$load("kjZZD"),
    $469d0953f050b025$var$load("3JSgG"),
    $469d0953f050b025$var$load("9AXkC"),
    $469d0953f050b025$var$load("ffEVr"),
    $469d0953f050b025$var$load("28arV"),
    $469d0953f050b025$var$load("l1BQC"),
    $469d0953f050b025$var$load("jlSF3"),
    $469d0953f050b025$var$load("2vAWg"),
    $469d0953f050b025$var$load("7cABH"),
    $469d0953f050b025$var$load("31vk5"),
    $469d0953f050b025$var$load("4pqtR"),
    $469d0953f050b025$var$load("5XqRg"),
    $469d0953f050b025$var$load("2uVTT"),
    $469d0953f050b025$var$load("hhss7"),
    $469d0953f050b025$var$load("Wowvf"),
    $469d0953f050b025$var$load("5RR9C"),
    $469d0953f050b025$var$load("2PePB"),
    $469d0953f050b025$var$load("bIPPg"),
    $469d0953f050b025$var$load("lnKog"),
    $469d0953f050b025$var$load("h3ABO"),
    $469d0953f050b025$var$load("kC80R"),
    $469d0953f050b025$var$load("7EorR"),
    $469d0953f050b025$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("KFpBB", function(module, exports) {

let $08c46b8d298251cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08c46b8d298251cc$var$load("7do1E"),
    $08c46b8d298251cc$var$load("77dkW"),
    $08c46b8d298251cc$var$load("2YffH"),
    $08c46b8d298251cc$var$load("b7OPx"),
    $08c46b8d298251cc$var$load("lqFMg"),
    $08c46b8d298251cc$var$load("gELW6"),
    $08c46b8d298251cc$var$load("4hDGB"),
    $08c46b8d298251cc$var$load("2PePB"),
    $08c46b8d298251cc$var$load("eBRUf"),
    $08c46b8d298251cc$var$load("hwT9D"),
    $08c46b8d298251cc$var$load("j4Bpe"),
    $08c46b8d298251cc$var$load("h4Nf7"),
    $08c46b8d298251cc$var$load("7f9Fz"),
    $08c46b8d298251cc$var$load("8YSo7"),
    $08c46b8d298251cc$var$load("g9CVe"),
    $08c46b8d298251cc$var$load("9hYRW"),
    $08c46b8d298251cc$var$load("kpm7S"),
    $08c46b8d298251cc$var$load("6wr18"),
    $08c46b8d298251cc$var$load("kjZZD"),
    $08c46b8d298251cc$var$load("3JSgG"),
    $08c46b8d298251cc$var$load("9AXkC"),
    $08c46b8d298251cc$var$load("ffEVr"),
    $08c46b8d298251cc$var$load("28arV"),
    $08c46b8d298251cc$var$load("l1BQC"),
    $08c46b8d298251cc$var$load("jlSF3"),
    $08c46b8d298251cc$var$load("2vAWg"),
    $08c46b8d298251cc$var$load("7cABH"),
    $08c46b8d298251cc$var$load("31vk5"),
    $08c46b8d298251cc$var$load("4pqtR"),
    $08c46b8d298251cc$var$load("5XqRg"),
    $08c46b8d298251cc$var$load("bIPPg"),
    $08c46b8d298251cc$var$load("2uVTT"),
    $08c46b8d298251cc$var$load("hhss7"),
    $08c46b8d298251cc$var$load("Wowvf"),
    $08c46b8d298251cc$var$load("5RR9C"),
    $08c46b8d298251cc$var$load("h3ABO"),
    $08c46b8d298251cc$var$load("kC80R"),
    $08c46b8d298251cc$var$load("7EorR"),
    $08c46b8d298251cc$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("4e9mM", function(module, exports) {

let $313fbc2f3844e0dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $313fbc2f3844e0dc$var$load("7do1E"),
    $313fbc2f3844e0dc$var$load("77dkW"),
    $313fbc2f3844e0dc$var$load("2YffH"),
    $313fbc2f3844e0dc$var$load("b7OPx"),
    $313fbc2f3844e0dc$var$load("lqFMg"),
    $313fbc2f3844e0dc$var$load("gELW6"),
    $313fbc2f3844e0dc$var$load("4hDGB"),
    $313fbc2f3844e0dc$var$load("2PePB"),
    $313fbc2f3844e0dc$var$load("eBRUf"),
    $313fbc2f3844e0dc$var$load("hwT9D"),
    $313fbc2f3844e0dc$var$load("j4Bpe"),
    $313fbc2f3844e0dc$var$load("h4Nf7"),
    $313fbc2f3844e0dc$var$load("7f9Fz"),
    $313fbc2f3844e0dc$var$load("8YSo7"),
    $313fbc2f3844e0dc$var$load("g9CVe"),
    $313fbc2f3844e0dc$var$load("9hYRW"),
    $313fbc2f3844e0dc$var$load("kpm7S"),
    $313fbc2f3844e0dc$var$load("6wr18"),
    $313fbc2f3844e0dc$var$load("kjZZD"),
    $313fbc2f3844e0dc$var$load("3JSgG"),
    $313fbc2f3844e0dc$var$load("9AXkC"),
    $313fbc2f3844e0dc$var$load("ffEVr"),
    $313fbc2f3844e0dc$var$load("28arV"),
    $313fbc2f3844e0dc$var$load("l1BQC"),
    $313fbc2f3844e0dc$var$load("jlSF3"),
    $313fbc2f3844e0dc$var$load("2vAWg"),
    $313fbc2f3844e0dc$var$load("7cABH"),
    $313fbc2f3844e0dc$var$load("31vk5"),
    $313fbc2f3844e0dc$var$load("4pqtR"),
    $313fbc2f3844e0dc$var$load("5XqRg"),
    $313fbc2f3844e0dc$var$load("bIPPg"),
    $313fbc2f3844e0dc$var$load("2uVTT"),
    $313fbc2f3844e0dc$var$load("hhss7"),
    $313fbc2f3844e0dc$var$load("Wowvf"),
    $313fbc2f3844e0dc$var$load("5RR9C"),
    $313fbc2f3844e0dc$var$load("h3ABO"),
    $313fbc2f3844e0dc$var$load("kC80R"),
    $313fbc2f3844e0dc$var$load("7EorR"),
    $313fbc2f3844e0dc$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("gcnRn", function(module, exports) {

let $bcb04664b0e7f05a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bcb04664b0e7f05a$var$load("7do1E"),
    $bcb04664b0e7f05a$var$load("77dkW"),
    $bcb04664b0e7f05a$var$load("2YffH"),
    $bcb04664b0e7f05a$var$load("b7OPx"),
    $bcb04664b0e7f05a$var$load("lqFMg"),
    $bcb04664b0e7f05a$var$load("gELW6"),
    $bcb04664b0e7f05a$var$load("4hDGB"),
    $bcb04664b0e7f05a$var$load("2PePB"),
    $bcb04664b0e7f05a$var$load("eBRUf"),
    $bcb04664b0e7f05a$var$load("hwT9D"),
    $bcb04664b0e7f05a$var$load("j4Bpe"),
    $bcb04664b0e7f05a$var$load("h4Nf7"),
    $bcb04664b0e7f05a$var$load("7f9Fz"),
    $bcb04664b0e7f05a$var$load("8YSo7"),
    $bcb04664b0e7f05a$var$load("g9CVe"),
    $bcb04664b0e7f05a$var$load("9hYRW"),
    $bcb04664b0e7f05a$var$load("kpm7S"),
    $bcb04664b0e7f05a$var$load("6wr18"),
    $bcb04664b0e7f05a$var$load("kjZZD"),
    $bcb04664b0e7f05a$var$load("3JSgG"),
    $bcb04664b0e7f05a$var$load("9AXkC"),
    $bcb04664b0e7f05a$var$load("ffEVr"),
    $bcb04664b0e7f05a$var$load("28arV"),
    $bcb04664b0e7f05a$var$load("l1BQC"),
    $bcb04664b0e7f05a$var$load("jlSF3"),
    $bcb04664b0e7f05a$var$load("2vAWg"),
    $bcb04664b0e7f05a$var$load("7cABH"),
    $bcb04664b0e7f05a$var$load("31vk5"),
    $bcb04664b0e7f05a$var$load("4pqtR"),
    $bcb04664b0e7f05a$var$load("5XqRg"),
    $bcb04664b0e7f05a$var$load("bIPPg"),
    $bcb04664b0e7f05a$var$load("2uVTT"),
    $bcb04664b0e7f05a$var$load("hhss7"),
    $bcb04664b0e7f05a$var$load("Wowvf"),
    $bcb04664b0e7f05a$var$load("5RR9C"),
    $bcb04664b0e7f05a$var$load("h3ABO"),
    $bcb04664b0e7f05a$var$load("kC80R"),
    $bcb04664b0e7f05a$var$load("7EorR"),
    $bcb04664b0e7f05a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("i52gf", function(module, exports) {

let $d29a729a0db7efa2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d29a729a0db7efa2$var$load("7do1E"),
    $d29a729a0db7efa2$var$load("77dkW"),
    $d29a729a0db7efa2$var$load("2YffH"),
    $d29a729a0db7efa2$var$load("b7OPx"),
    $d29a729a0db7efa2$var$load("lqFMg"),
    $d29a729a0db7efa2$var$load("gELW6"),
    $d29a729a0db7efa2$var$load("4hDGB"),
    $d29a729a0db7efa2$var$load("eBRUf"),
    $d29a729a0db7efa2$var$load("hwT9D"),
    $d29a729a0db7efa2$var$load("j4Bpe"),
    $d29a729a0db7efa2$var$load("h4Nf7"),
    $d29a729a0db7efa2$var$load("7f9Fz"),
    $d29a729a0db7efa2$var$load("8YSo7"),
    $d29a729a0db7efa2$var$load("g9CVe"),
    $d29a729a0db7efa2$var$load("9hYRW"),
    $d29a729a0db7efa2$var$load("kpm7S"),
    $d29a729a0db7efa2$var$load("6wr18"),
    $d29a729a0db7efa2$var$load("kjZZD"),
    $d29a729a0db7efa2$var$load("3JSgG"),
    $d29a729a0db7efa2$var$load("9AXkC"),
    $d29a729a0db7efa2$var$load("ffEVr"),
    $d29a729a0db7efa2$var$load("28arV"),
    $d29a729a0db7efa2$var$load("l1BQC"),
    $d29a729a0db7efa2$var$load("jlSF3"),
    $d29a729a0db7efa2$var$load("2vAWg"),
    $d29a729a0db7efa2$var$load("7cABH"),
    $d29a729a0db7efa2$var$load("31vk5"),
    $d29a729a0db7efa2$var$load("4pqtR"),
    $d29a729a0db7efa2$var$load("5XqRg"),
    $d29a729a0db7efa2$var$load("2uVTT"),
    $d29a729a0db7efa2$var$load("hhss7"),
    $d29a729a0db7efa2$var$load("Wowvf"),
    $d29a729a0db7efa2$var$load("5RR9C"),
    $d29a729a0db7efa2$var$load("2PePB"),
    $d29a729a0db7efa2$var$load("bIPPg"),
    $d29a729a0db7efa2$var$load("lnKog"),
    $d29a729a0db7efa2$var$load("h3ABO"),
    $d29a729a0db7efa2$var$load("kC80R"),
    $d29a729a0db7efa2$var$load("7EorR"),
    $d29a729a0db7efa2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("4doEc", function(module, exports) {

let $311b7ec1ee83a155$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $311b7ec1ee83a155$var$load("2YffH"),
    $311b7ec1ee83a155$var$load("b7OPx"),
    $311b7ec1ee83a155$var$load("lqFMg"),
    $311b7ec1ee83a155$var$load("gELW6"),
    $311b7ec1ee83a155$var$load("4hDGB"),
    $311b7ec1ee83a155$var$load("1H5IN"),
    $311b7ec1ee83a155$var$load("eBRUf"),
    $311b7ec1ee83a155$var$load("hwT9D"),
    $311b7ec1ee83a155$var$load("j4Bpe"),
    $311b7ec1ee83a155$var$load("h4Nf7"),
    $311b7ec1ee83a155$var$load("7f9Fz"),
    $311b7ec1ee83a155$var$load("8YSo7"),
    $311b7ec1ee83a155$var$load("7do1E"),
    $311b7ec1ee83a155$var$load("77dkW"),
    $311b7ec1ee83a155$var$load("g9CVe"),
    $311b7ec1ee83a155$var$load("9hYRW"),
    $311b7ec1ee83a155$var$load("kpm7S"),
    $311b7ec1ee83a155$var$load("6wr18"),
    $311b7ec1ee83a155$var$load("kjZZD"),
    $311b7ec1ee83a155$var$load("3JSgG"),
    $311b7ec1ee83a155$var$load("9AXkC"),
    $311b7ec1ee83a155$var$load("ffEVr"),
    $311b7ec1ee83a155$var$load("28arV"),
    $311b7ec1ee83a155$var$load("l1BQC"),
    $311b7ec1ee83a155$var$load("jlSF3"),
    $311b7ec1ee83a155$var$load("2vAWg"),
    $311b7ec1ee83a155$var$load("7cABH"),
    $311b7ec1ee83a155$var$load("31vk5"),
    $311b7ec1ee83a155$var$load("4pqtR"),
    $311b7ec1ee83a155$var$load("5XqRg"),
    $311b7ec1ee83a155$var$load("2uVTT"),
    $311b7ec1ee83a155$var$load("hhss7"),
    $311b7ec1ee83a155$var$load("Wowvf"),
    $311b7ec1ee83a155$var$load("5RR9C"),
    $311b7ec1ee83a155$var$load("2PePB"),
    $311b7ec1ee83a155$var$load("bIPPg"),
    $311b7ec1ee83a155$var$load("lnKog"),
    $311b7ec1ee83a155$var$load("h3ABO"),
    $311b7ec1ee83a155$var$load("kC80R"),
    $311b7ec1ee83a155$var$load("7EorR"),
    $311b7ec1ee83a155$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("kFJwL", function(module, exports) {

let $f0caf3c7b012306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0caf3c7b012306d$var$load("2YffH"),
    $f0caf3c7b012306d$var$load("b7OPx"),
    $f0caf3c7b012306d$var$load("lqFMg"),
    $f0caf3c7b012306d$var$load("gELW6"),
    $f0caf3c7b012306d$var$load("4hDGB"),
    $f0caf3c7b012306d$var$load("1H5IN"),
    $f0caf3c7b012306d$var$load("eBRUf"),
    $f0caf3c7b012306d$var$load("hwT9D"),
    $f0caf3c7b012306d$var$load("j4Bpe"),
    $f0caf3c7b012306d$var$load("h4Nf7"),
    $f0caf3c7b012306d$var$load("7f9Fz"),
    $f0caf3c7b012306d$var$load("8YSo7"),
    $f0caf3c7b012306d$var$load("7do1E"),
    $f0caf3c7b012306d$var$load("77dkW"),
    $f0caf3c7b012306d$var$load("g9CVe"),
    $f0caf3c7b012306d$var$load("9hYRW"),
    $f0caf3c7b012306d$var$load("kpm7S"),
    $f0caf3c7b012306d$var$load("6wr18"),
    $f0caf3c7b012306d$var$load("kjZZD"),
    $f0caf3c7b012306d$var$load("3JSgG"),
    $f0caf3c7b012306d$var$load("9AXkC"),
    $f0caf3c7b012306d$var$load("ffEVr"),
    $f0caf3c7b012306d$var$load("28arV"),
    $f0caf3c7b012306d$var$load("l1BQC"),
    $f0caf3c7b012306d$var$load("jlSF3"),
    $f0caf3c7b012306d$var$load("2vAWg"),
    $f0caf3c7b012306d$var$load("7cABH"),
    $f0caf3c7b012306d$var$load("31vk5"),
    $f0caf3c7b012306d$var$load("4pqtR"),
    $f0caf3c7b012306d$var$load("5XqRg"),
    $f0caf3c7b012306d$var$load("2uVTT"),
    $f0caf3c7b012306d$var$load("hhss7"),
    $f0caf3c7b012306d$var$load("Wowvf"),
    $f0caf3c7b012306d$var$load("5RR9C"),
    $f0caf3c7b012306d$var$load("2PePB"),
    $f0caf3c7b012306d$var$load("bIPPg"),
    $f0caf3c7b012306d$var$load("lnKog"),
    $f0caf3c7b012306d$var$load("h3ABO"),
    $f0caf3c7b012306d$var$load("kC80R"),
    $f0caf3c7b012306d$var$load("7EorR"),
    $f0caf3c7b012306d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("5shOo", function(module, exports) {

let $3f8d62588ff52c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f8d62588ff52c9b$var$load("7do1E"),
    $3f8d62588ff52c9b$var$load("77dkW"),
    $3f8d62588ff52c9b$var$load("2YffH"),
    $3f8d62588ff52c9b$var$load("b7OPx"),
    $3f8d62588ff52c9b$var$load("lqFMg"),
    $3f8d62588ff52c9b$var$load("gELW6"),
    $3f8d62588ff52c9b$var$load("4hDGB"),
    $3f8d62588ff52c9b$var$load("2PePB"),
    $3f8d62588ff52c9b$var$load("eBRUf"),
    $3f8d62588ff52c9b$var$load("hwT9D"),
    $3f8d62588ff52c9b$var$load("j4Bpe"),
    $3f8d62588ff52c9b$var$load("h4Nf7"),
    $3f8d62588ff52c9b$var$load("7f9Fz"),
    $3f8d62588ff52c9b$var$load("8YSo7"),
    $3f8d62588ff52c9b$var$load("g9CVe"),
    $3f8d62588ff52c9b$var$load("9hYRW"),
    $3f8d62588ff52c9b$var$load("kpm7S"),
    $3f8d62588ff52c9b$var$load("6wr18"),
    $3f8d62588ff52c9b$var$load("kjZZD"),
    $3f8d62588ff52c9b$var$load("3JSgG"),
    $3f8d62588ff52c9b$var$load("9AXkC"),
    $3f8d62588ff52c9b$var$load("ffEVr"),
    $3f8d62588ff52c9b$var$load("28arV"),
    $3f8d62588ff52c9b$var$load("l1BQC"),
    $3f8d62588ff52c9b$var$load("jlSF3"),
    $3f8d62588ff52c9b$var$load("2vAWg"),
    $3f8d62588ff52c9b$var$load("7cABH"),
    $3f8d62588ff52c9b$var$load("31vk5"),
    $3f8d62588ff52c9b$var$load("4pqtR"),
    $3f8d62588ff52c9b$var$load("5XqRg"),
    $3f8d62588ff52c9b$var$load("bIPPg"),
    $3f8d62588ff52c9b$var$load("2uVTT"),
    $3f8d62588ff52c9b$var$load("hhss7"),
    $3f8d62588ff52c9b$var$load("Wowvf"),
    $3f8d62588ff52c9b$var$load("5RR9C"),
    $3f8d62588ff52c9b$var$load("h3ABO"),
    $3f8d62588ff52c9b$var$load("kC80R"),
    $3f8d62588ff52c9b$var$load("7EorR"),
    $3f8d62588ff52c9b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("3Hycf", function(module, exports) {

let $2b1fe9f7f738c36c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b1fe9f7f738c36c$var$load("7do1E"),
    $2b1fe9f7f738c36c$var$load("77dkW"),
    $2b1fe9f7f738c36c$var$load("2YffH"),
    $2b1fe9f7f738c36c$var$load("b7OPx"),
    $2b1fe9f7f738c36c$var$load("lqFMg"),
    $2b1fe9f7f738c36c$var$load("gELW6"),
    $2b1fe9f7f738c36c$var$load("4hDGB"),
    $2b1fe9f7f738c36c$var$load("eBRUf"),
    $2b1fe9f7f738c36c$var$load("hwT9D"),
    $2b1fe9f7f738c36c$var$load("j4Bpe"),
    $2b1fe9f7f738c36c$var$load("h4Nf7"),
    $2b1fe9f7f738c36c$var$load("7f9Fz"),
    $2b1fe9f7f738c36c$var$load("8YSo7"),
    $2b1fe9f7f738c36c$var$load("g9CVe"),
    $2b1fe9f7f738c36c$var$load("9hYRW"),
    $2b1fe9f7f738c36c$var$load("kpm7S"),
    $2b1fe9f7f738c36c$var$load("6wr18"),
    $2b1fe9f7f738c36c$var$load("kjZZD"),
    $2b1fe9f7f738c36c$var$load("3JSgG"),
    $2b1fe9f7f738c36c$var$load("9AXkC"),
    $2b1fe9f7f738c36c$var$load("ffEVr"),
    $2b1fe9f7f738c36c$var$load("28arV"),
    $2b1fe9f7f738c36c$var$load("l1BQC"),
    $2b1fe9f7f738c36c$var$load("jlSF3"),
    $2b1fe9f7f738c36c$var$load("2vAWg"),
    $2b1fe9f7f738c36c$var$load("7cABH"),
    $2b1fe9f7f738c36c$var$load("31vk5"),
    $2b1fe9f7f738c36c$var$load("4pqtR"),
    $2b1fe9f7f738c36c$var$load("5XqRg"),
    $2b1fe9f7f738c36c$var$load("2uVTT"),
    $2b1fe9f7f738c36c$var$load("hhss7"),
    $2b1fe9f7f738c36c$var$load("Wowvf"),
    $2b1fe9f7f738c36c$var$load("5RR9C"),
    $2b1fe9f7f738c36c$var$load("2PePB"),
    $2b1fe9f7f738c36c$var$load("bIPPg"),
    $2b1fe9f7f738c36c$var$load("lnKog"),
    $2b1fe9f7f738c36c$var$load("h3ABO"),
    $2b1fe9f7f738c36c$var$load("kC80R"),
    $2b1fe9f7f738c36c$var$load("7EorR"),
    $2b1fe9f7f738c36c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("5S3Gg", function(module, exports) {

let $4464d9cf9d8cfe99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4464d9cf9d8cfe99$var$load("7do1E"),
    $4464d9cf9d8cfe99$var$load("77dkW"),
    $4464d9cf9d8cfe99$var$load("2YffH"),
    $4464d9cf9d8cfe99$var$load("b7OPx"),
    $4464d9cf9d8cfe99$var$load("lqFMg"),
    $4464d9cf9d8cfe99$var$load("gELW6"),
    $4464d9cf9d8cfe99$var$load("4hDGB"),
    $4464d9cf9d8cfe99$var$load("eBRUf"),
    $4464d9cf9d8cfe99$var$load("hwT9D"),
    $4464d9cf9d8cfe99$var$load("j4Bpe"),
    $4464d9cf9d8cfe99$var$load("h4Nf7"),
    $4464d9cf9d8cfe99$var$load("7f9Fz"),
    $4464d9cf9d8cfe99$var$load("8YSo7"),
    $4464d9cf9d8cfe99$var$load("g9CVe"),
    $4464d9cf9d8cfe99$var$load("9hYRW"),
    $4464d9cf9d8cfe99$var$load("kpm7S"),
    $4464d9cf9d8cfe99$var$load("6wr18"),
    $4464d9cf9d8cfe99$var$load("kjZZD"),
    $4464d9cf9d8cfe99$var$load("3JSgG"),
    $4464d9cf9d8cfe99$var$load("9AXkC"),
    $4464d9cf9d8cfe99$var$load("ffEVr"),
    $4464d9cf9d8cfe99$var$load("28arV"),
    $4464d9cf9d8cfe99$var$load("l1BQC"),
    $4464d9cf9d8cfe99$var$load("jlSF3"),
    $4464d9cf9d8cfe99$var$load("2vAWg"),
    $4464d9cf9d8cfe99$var$load("7cABH"),
    $4464d9cf9d8cfe99$var$load("31vk5"),
    $4464d9cf9d8cfe99$var$load("4pqtR"),
    $4464d9cf9d8cfe99$var$load("5XqRg"),
    $4464d9cf9d8cfe99$var$load("2uVTT"),
    $4464d9cf9d8cfe99$var$load("hhss7"),
    $4464d9cf9d8cfe99$var$load("Wowvf"),
    $4464d9cf9d8cfe99$var$load("5RR9C"),
    $4464d9cf9d8cfe99$var$load("2PePB"),
    $4464d9cf9d8cfe99$var$load("bIPPg"),
    $4464d9cf9d8cfe99$var$load("lnKog"),
    $4464d9cf9d8cfe99$var$load("h3ABO"),
    $4464d9cf9d8cfe99$var$load("kC80R"),
    $4464d9cf9d8cfe99$var$load("7EorR"),
    $4464d9cf9d8cfe99$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lYk0G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lYk0G", function(module, exports) {

let $ffeeb920d352edae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffeeb920d352edae$var$load("2PePB"),
    $ffeeb920d352edae$var$load("bIPPg"),
    $ffeeb920d352edae$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $aXWIB = parcelRequire("aXWIB");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $aXWIB.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $aXWIB.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.c692893a.js.map
